"use client";

import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Contact() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from("[data-contact]", {
        scrollTrigger: { trigger: ref.current, start: "top 85%", toggleActions: "play none none none" },
        y: 24,
        autoAlpha: 0,
        duration: 0.5,
        ease: "power2.out",
      });
    }, ref);
    return () => ctx.revert();
  }, []);

  return (
    <section id="contact" ref={ref} className="section">
      <div
        data-contact
        className="relative rounded-lg p-6 sm:p-12 text-center overflow-hidden"
        style={{ background: "var(--surface)", boxShadow: "var(--shadow-card)", border: "1px solid var(--border-subtle)" }}
      >
        <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 rounded-full blur-[70px] pointer-events-none" style={{ background: "rgba(46,196,182,0.05)" }} />

        <div className="relative">
          <h2 className="text-xl sm:text-2xl font-bold tracking-tight">
            Need help?
          </h2>
          <p className="text-sm text-[#b3b3b3] mt-2 max-w-md mx-auto">
            Bug reports, feature requests, license issues, or just want to say hi.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <a
              href="mailto:hello@8dfy.xyz"
              title="Email 8Dfy support"
              className="flex items-center gap-2.5 max-w-full px-4 sm:px-6 py-3 rounded-full text-[10px] sm:text-[11px] font-bold uppercase tracking-[1.4px] text-[#b3b3b3] hover:text-white transition-all duration-200 break-all"
              style={{ border: "1px solid #4d4d4d" }}
            >
              <svg className="w-4 h-4 shrink-0" viewBox="0 0 20 20" fill="none">
                <rect x="2" y="4" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" />
                <path d="M2 6l8 5 8-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
              hello@8dfy.xyz
            </a>
          </div>

          <p className="text-[11px] text-[#b3b3b3]/70 mt-6 uppercase tracking-[1px]">
            We typically reply within 24 hours.
          </p>
        </div>
      </div>
    </section>
  );
}
